import {
  Button,
  Grid,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Space,
  Text,
  TextLabel,
} from '@tonic-one/react';
import { useTranslation } from 'react-i18next';
import { DlpTemplateModalNameEnum, DlpTemplateModalState } from '../type';
import { PolicyApi } from '@Apis';
import LoadingBtn from '@Components/Common/LoadingBtn';

export const DeleteModal = ({
  modalState,
  onClose,
  refreshTable,
}: {
  modalState: DlpTemplateModalState;
  onClose: () => void;
  refreshTable: () => void;
}) => {
  const { t } = useTranslation(['common', 'policy']);

  const deleteDlpTemplate = async () => {
    try {
      const res = await PolicyApi.deleteDlpTemplateById(
        modalState.data.cfgIndex
      );
      const errorCode = res?.data?.details?.[0]?.code;
      if (errorCode === -115) {
        window.showNotification({
          titleMsg: t('errors.policy.POLICY_API;DELETE_TEMPLATE_FAILURE;-115', {
            param: modalState.data.dpTemplateName,
          }),
          severity: 'error',
        });
        return;
      }
      window.showNotification({
        titleMsg: t('policy.complianceTemplates.deleteSuccessfully'),
        severity: 'success',
      });
    } catch (error) {
      console.error(error);
      window.showNotification({
        titleMsg: t('common.apiException.internalError'),
        severity: 'error',
      });
    } finally {
      refreshTable();
      onClose();
    }
  };

  return (
    <Modal
      ensureFocus={true}
      autoFocus={false}
      closeOnEsc={true}
      closeOnOutsideClick={false}
      isClosable={true}
      isOpen={modalState.name === DlpTemplateModalNameEnum.Delete}
      onClose={onClose}
      size="sm"
    >
      <ModalOverlay opacity={0.9} />
      <ModalContent>
        <ModalBody>
          <Text>{t('policy.complianceTemplates.deleteConfirm')}</Text>
          <Grid
            gridTemplateColumns="max-content auto"
            gridColumnGap="4px"
            gridRowGap="8px"
            pt="16px"
          >
            <TextLabel>{t('common.label.enterName')}:</TextLabel>
            <Text>{modalState.data.dpTemplateName}</Text>
            <TextLabel>{t('common.label.description')}:</TextLabel>
            <Text>{modalState.data.dpTemplateDesc}</Text>
          </Grid>
        </ModalBody>
        <ModalFooter>
          <LoadingBtn onClick={deleteDlpTemplate} variant="primary">
            {t('common.button.ok')}
          </LoadingBtn>
          <Space width="2x" />
          <Button minWidth="20x" onClick={onClose}>
            {t('common.button.cancel')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
